import { Rating } from '@/domains/core/tamagoshiTailwind/components/Rating/Rating';
import { rating } from '@/domains/core/tamagoshiTailwind/translations';
import { useReviewsStats } from '@/domains/productDiscovery/ArticleReviews/ReviewsStats.ducks';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';

import { numberOfReview } from '../Rating/translations';

export const HeaderRating = () => {
  const reviews = useReviewsStats();
  const { goToReview } = useSidePanel();

  return (
    <>
      {reviews.total > 0 && (
        <Rating
          aria-label={rating.ariaLabel}
          reviewsLabel={(value) =>
            `${numberOfReview.format({ totalRating: value })}`
          }
          onClick={goToReview}
          size="M"
          value={reviews.average}
          reviewsCount={reviews.total}
        />
      )}
    </>
  );
};
